export default "/images/4c5359e085f29feaddd7ce9f746e0487.avif";